import { GCP_ALL_REGION_CODES, GCP_SELECT_ALL_REGIONS_VALUE } from './gcpRegions';

export type GcpFormDetails = {
  projectId: string;
  region: string;
  serviceAccount: string;
  zone: string;
};

export function normalizeGcpDetailsForApi(gcp: GcpFormDetails) {
  const projectId = (gcp.projectId ?? '').trim();
  const serviceAccount = (gcp.serviceAccount ?? '').trim();
  const zone = (gcp.zone ?? '').trim();

  if (gcp.region === GCP_SELECT_ALL_REGIONS_VALUE) {
    return {
      projectId,
      serviceAccount,
      region: '',
      regions: [...GCP_ALL_REGION_CODES],
      allRegions: true,
      ...(zone ? { zone } : {})
    };
  }

  return {
    projectId,
    serviceAccount,
    region: (gcp.region ?? '').trim(),
    ...(zone ? { zone } : {})
  };
}
